// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--mSIkZ","table":"table--olJkJ"};